import React, { useState } from 'react';
import Swal from 'sweetalert2';
import viajeImage from '../assets/viaje.jpg';
import { useNavigate } from 'react-router-dom';
import '../styles/disenosegurosbase.css';

export default function SeguroDeViajes() {

  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    nombre: '',
    edad: '',
    genero: '',
    tiempoEstadia: '',
    destino: '',
    salida: '',
    correo: '',
    numero: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

const validarFormulario = () => {
  const correoRegex = /^[\w-.]+@(gmail|hotmail|outlook|yahoo)\.[a-zA-Z]{2,6}$/;
  const telefonoRegex = /^\d{10}$/;

  // Validar campos vacíos
  for (const campo in formData) {
    if (formData[campo].toString().trim() === '') {
      Swal.fire('Campos incompletos', 'Por favor llena todos los campos obligatorios.', 'warning');
      return false;
    }
  }

  const edadNum = parseInt(formData.edad);
  if (isNaN(edadNum) || edadNum <= 0 || edadNum > 100) {
    Swal.fire('Error', 'Edad inválida.', 'error');
    return false;
  }

  if (!correoRegex.test(formData.correo.trim())) {
    Swal.fire('Error', 'Correo inválido. Solo se aceptan Gmail, Hotmail, Outlook y Yahoo.', 'error');
    return false;
  }


  if (!telefonoRegex.test(formData.numero.trim())) {
    Swal.fire('Error', 'Número de teléfono inválido. Debe contener 10 dígitos.', 'error');
    return false;
  }

  return true;
};


  const handleSubmit = async () => {
    if (!validarFormulario()) return;

    try {
      const response = await fetch(`https://ricardodiaztuasesorfinanciero.com/api/citaseguroviajes`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      const result = await response.json();
      if (response.ok) {
      Swal.fire({
        title: "Gracias!Nos pondremos en contacto pronto!",
        icon: "success",
        draggable: true
      });
        setFormData({ nombre: '', edad: '', genero: '', tiempoEstadia: '', destino: '', salida: '', correo: '', numero: '' });
      } else {
        Swal.fire('Error', result.error || 'Error al enviar los datos', 'error');
      }
    } catch (error) {
      Swal.fire('Error', 'Error en la conexión.', 'error');
    }
  };

  return (
    <>
      <button
        onClick={() => navigate('/')}
        className="seguro-back"
      >
        ← Regresar al Menú
      </button>
      <div className="seguro-container">
        <div className="seguro-left">
          <img src={viajeImage} alt="Seguro de viaje" />
          <div className="seguro-overlay">
            <h1>¿Listo para tu aventura?</h1>
            <p>
              Protege tu viaje con una cobertura personalizada. Completa el formulario para obtener tu cotización.
            </p>
          </div>
        </div>
        <div className="seguro-form">
        <h2>Cotización Seguro de Viajes</h2>

        <label>Nombre:</label>
        <input name="nombre" value={formData.nombre} onChange={handleChange}  />

        <label>Edad:</label>
        <input name="edad" type="number" value={formData.edad} onChange={handleChange}  />

        <label>Género:</label>
        <select name="genero" value={formData.genero} onChange={handleChange} >
          <option value="">Selecciona</option>
          <option value="Masculino">Masculino</option>
          <option value="Femenino">Femenino</option>
        </select>

        <label>Destino:</label>
        <input name="destino" value={formData.destino} onChange={handleChange}  />

        <label>Fecha de salida:</label>
        <input name="salida" value={formData.salida} onChange={handleChange}  placeholder="Ej. 2025-07-10" />

        <label>Tiempo de estadía:</label>
        <input name="tiempoEstadia" value={formData.tiempoEstadia} onChange={handleChange}  placeholder="Ej. 7 días" />

        <label>Correo electrónico:</label>
        <input name="correo" value={formData.correo} onChange={handleChange}  />

        <label>Número de teléfono:</label>
        <input name="numero" value={formData.numero} onChange={handleChange}  />

        <button onClick={handleSubmit} className="seguro-btn">Enviar</button>
        <p
          onClick={() => navigate("/pantallaCIT")}
          className="seguro-link"
        >
          ¿Quieres atencion mas directa? Agenda tu cita aquí!
        </p>
      </div>
    </div>
  </>
  );
}
